import { Chip } from '@mui/material'

interface Props {
  stageLabel: string
}

export const TaskStageChip = ({ stageLabel }: Props) => {
  return <Chip label={stageLabel} color="neutral" title={stageLabel} />
}
